export default __webpack_public_path__ + "static/media/ic_montserrat.ccf70f69.svg";